import React from 'react';
import {
  Globe, Server, Calendar, RefreshCw, Key,
  ExternalLink, Edit2, Trash2, ShieldCheck, ShieldAlert, AlertCircle
} from 'lucide-react';

const WhatsAppIcon = ({ size = 16, style = {} }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="currentColor"
    viewBox="0 0 24 24"
    style={style}
  >
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.513 2.262 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.73-1.458L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.625 1.451 5.432.002 9.851-4.414 9.855-9.843.002-2.63-1.023-5.101-2.886-6.968-1.863-1.867-4.347-2.894-6.98-2.896-5.433 0-9.854 4.417-9.858 9.848-.002 1.81.488 3.579 1.419 5.141L1.896 22.15l6.3-1.652zM17.07 14.67c-.276-.138-1.636-.807-1.89-.899-.253-.093-.437-.138-.621.138-.184.276-.713.899-.874 1.084-.16.184-.321.207-.597.069-.276-.138-1.168-.43-2.226-1.374-.823-.733-1.378-1.64-1.539-1.916-.16-.276-.017-.425.12-.562.124-.124.276-.322.414-.483.138-.161.184-.276.276-.46.092-.184.046-.345-.023-.483-.069-.138-.621-1.496-.85-2.05-.224-.54-.449-.465-.621-.474-.16-.008-.344-.01-.528-.01-.184 0-.483.069-.736.345-.253.276-.966.943-.966 2.3 0 1.357.989 2.668 1.127 2.852.138.184 1.947 2.972 4.717 4.164.659.284 1.173.453 1.574.58.662.21 1.265.18 1.741.11.531-.078 1.636-.669 1.868-1.313.23-.643.23-1.196.16-1.312-.069-.115-.253-.184-.53-.322z" />
  </svg>
);

export default function DomainTable({ domains, onSelect, onEdit, onDelete, onRenew, onToggleAmc, loading }) {
  if (!domains || domains.length === 0) {
    if (loading) {
      return (
        <div className="glass-panel" style={{ overflowX: 'auto', background: '#ffffff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.80rem' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #e2e8f0', color: 'var(--text-muted)', background: '#f8fafc' }}>
                <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Domain Name</th>
                <th style={{ padding: '8px 12px', fontWeight: '700' }}>Status</th>
                <th style={{ padding: '8px 12px', fontWeight: '700' }}>Registrar</th>
                <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Hosting</th>
                <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Domain Date</th>
                <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Hosting Renew</th>
                <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Hosting Cost</th>
                <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Domain Cost</th>
                <th style={{ padding: '8px 12px', fontWeight: '700' }}>AMC</th>
                <th style={{ padding: '8px 12px', fontWeight: '700' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="10" style={{ padding: '40px', textAlign: 'center', color: 'var(--text-muted)' }}>
                  Loading domain details...
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="glass-panel" style={{ padding: '40px', textAlign: 'center', color: 'var(--text-muted)', background: '#ffffff' }}>
        No domains found. Try adding a new domain or clearing filters!
      </div>
    );
  }

  const getStatusBadge = (status) => {
    switch (status) {
      case 'expired':
        return <span className="badge badge-expired"><AlertCircle size={12} /> Expired</span>;
      case 'urgent':
        return <span className="badge badge-urgent"><ShieldAlert size={12} /> Urgent</span>;
      case 'expiring_soon':
        return <span className="badge badge-expiring_soon"><ShieldAlert size={12} /> Soon</span>;
      default:
        return <span className="badge badge-active"><ShieldCheck size={12} /> Active</span>;
    }
  };

  return (
    <div className="glass-panel" style={{ overflowX: 'auto', background: '#ffffff' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.80rem' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #e2e8f0', color: 'var(--text-muted)', background: '#f8fafc' }}>
            <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Domain Name</th>
            <th style={{ padding: '8px 12px', fontWeight: '700' }}>Status</th>
            <th style={{ padding: '8px 12px', fontWeight: '700' }}>Registrar</th>
            <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Hosting</th>
            <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Domain Date</th>
            <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Hosting Renew</th>
            <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Hosting Cost</th>
            <th style={{ padding: '8px 12px', fontWeight: '700', whiteSpace: 'nowrap' }}>Domain Cost</th>
            <th style={{ padding: '8px 12px', fontWeight: '700' }}>AMC</th>
            <th style={{ padding: '8px 12px', fontWeight: '700' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {domains.map(domain => {
            const days = domain.daysRemaining;
            let daysColor = '#059669';
            if (days <= 0) daysColor = '#dc2626';
            else if (days <= 7) daysColor = '#ea580c';
            else if (days <= 30) daysColor = '#d97706';

            // Hosting renewal days logic
            let hostingDaysColor = '#059669';
            let hostingDays = 999;
            if (domain.hostingRenewDate) {
              const [hYear, hMonth, hDay] = domain.hostingRenewDate.split('T')[0].split('-').map(Number);
              const hDate = new Date(hYear, hMonth - 1, hDay);
              hDate.setHours(0, 0, 0, 0);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              hostingDays = Math.round((hDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

              if (hostingDays <= 0) hostingDaysColor = '#dc2626';
              else if (hostingDays <= 7) hostingDaysColor = '#ea580c';
              else if (hostingDays <= 30) hostingDaysColor = '#d97706';
            }

            // AMC counter logic
            const now = new Date();
            const currentYear = now.getFullYear();
            const amcPaidYear = domain.amcPaidYear || null; // year number like 2026
            const isAmcPaid = amcPaidYear >= currentYear;
            const amcNextDue = isAmcPaid ? `${amcPaidYear + 1}` : `${currentYear}`;

            return (
              <tr
                key={domain.id}
                style={{
                  borderBottom: '1px solid #f1f5f9',
                  cursor: 'pointer',
                  transition: 'background 0.15s'
                }}
                className="table-row-hover"
                onClick={() => onSelect(domain)}
              >
                {/* Domain Name */}
                <td style={{ padding: '8px 12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Globe size={13} color="#4f46e5" />
                    <div>
                      <span style={{ fontWeight: '700', color: '#0f172a' }}>{domain.domainName}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '1px' }}>
                        {domain.category && (
                          <span style={{ fontSize: '0.65rem', color: 'var(--text-dim)' }}>
                            {domain.category}
                          </span>
                        )}
                        {domain.category && domain.clientName && (
                          <span style={{ color: '#cbd5e1', fontSize: '0.65rem' }}>•</span>
                        )}
                        {domain.clientName && (
                          <span style={{ fontSize: '0.65rem', color: '#16a34a', fontWeight: '600' }} title="Client Name">
                            {domain.clientName}
                          </span>
                        )}
                      </div>
                    </div>
                    <a
                      href={`${domain.domainName}`}
                      target="_blank"
                      rel="noreferrer"
                      onClick={e => e.stopPropagation()}
                      style={{ color: 'var(--text-dim)', marginLeft: '2px' }}
                    >
                      <ExternalLink size={11} />
                    </a>
                  </div>
                </td>

                {/* Status */}
                <td style={{ padding: '8px 12px' }}>
                  {getStatusBadge(domain.computedStatus)}
                </td>

                {/* Registrar */}
                <td style={{ padding: '8px 12px', color: '#334155', whiteSpace: 'nowrap' }}>
                  {domain.registrar || '—'}
                </td>

                {/* Hosting */}
                <td style={{ padding: '8px 12px', color: '#334155', whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Server size={12} color="#64748b" />
                    <span>{domain.hostingProvider || '—'}</span>
                  </div>
                </td>

                {/* Domain Date */}
                <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Calendar size={12} color="var(--text-dim)" />
                    <span style={{ fontWeight: '600', color: '#0f172a' }}>{domain.renewalDate}</span>
                  </div>
                  <span style={{ fontSize: '0.65rem', color: daysColor, fontWeight: '700', display: 'block', marginTop: '1px' }}>
                    {days <= 0 ? `Expired (${Math.abs(days)}d ago)` : `${days}d left`}
                  </span>
                </td>

                {/* Hosting Renew Date */}
                <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                  {domain.hostingRenewDate ? (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <Calendar size={12} color="var(--text-dim)" />
                        <span style={{ fontWeight: '600', color: '#0f172a' }}>{domain.hostingRenewDate}</span>
                      </div>
                      <span style={{ fontSize: '0.65rem', color: hostingDaysColor, fontWeight: '700', display: 'block', marginTop: '1px' }}>
                        {hostingDays <= 0 ? `Expired (${Math.abs(hostingDays)}d ago)` : `${hostingDays}d left`}
                      </span>
                    </>
                  ) : (
                    <span style={{ color: '#94a3b8' }}>—</span>
                  )}
                </td>

                {/* Hosting Cost */}
                <td style={{ padding: '8px 12px', fontWeight: '700', color: '#059669', whiteSpace: 'nowrap' }}>
                  ₹{domain.hostingCost || 0}
                </td>

                {/* Domain Cost */}
                <td style={{ padding: '8px 12px', fontWeight: '700', color: '#059669', whiteSpace: 'nowrap' }}>
                  ₹{domain.cost || 0}
                  <span style={{ fontSize: '0.65rem', color: 'var(--text-dim)', fontWeight: 'normal' }}>/{domain.billingCycle === 'monthly' ? 'mo' : 'yr'}</span>
                </td>

                {/* AMC */}
                <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                  {domain.amcAmount > 0 ? (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            if (onToggleAmc) onToggleAmc(domain);
                          }}
                          style={{
                            display: 'inline-block',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '0.68rem',
                            fontWeight: '700',
                            cursor: 'pointer',
                            background: isAmcPaid ? '#dcfce7' : '#fef3c7',
                            color: isAmcPaid ? '#16a34a' : '#d97706',
                            border: `1px solid ${isAmcPaid ? '#bbf7d0' : '#fde68a'}`
                          }}
                          title="Click to toggle AMC status"
                        >
                          {isAmcPaid ? '✅ Paid' : '⏳ Pending'}
                        </span>
                      </div>
                      <span style={{ fontSize: '0.62rem', color: 'var(--text-dim)', display: 'block', marginTop: '1px' }}>
                        Next: {amcNextDue}
                      </span>
                    </>
                  ) : (
                    <span style={{ color: '#94a3b8' }}>—</span>
                  )}
                </td>

                {/* Actions */}
                <td style={{ padding: '8px 12px', textAlign: 'right' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }} onClick={e => e.stopPropagation()}>
                    {days <= 30 && (
                      <button
                        className="btn btn-renew"
                        style={{ padding: '3px 8px', fontSize: '0.7rem' }}
                        onClick={() => onRenew(domain.id)}
                        title="Renew Domain (+1 year)"
                      >
                        <RefreshCw size={10} /> Renew
                      </button>
                    )}

                    {domain.whatsappNo && (
                      <a
                        href={`https://wa.me/${domain.whatsappNo.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(`Hi, regarding your domain ${domain.domainName}...`)}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-secondary btn-icon"
                        style={{ padding: '4px', borderColor: '#25d366', color: '#25d366', background: '#f0fdf4' }}
                        title={`Chat with ${domain.clientName || 'Client'} on WhatsApp`}
                        onClick={e => e.stopPropagation()}
                      >
                        <WhatsAppIcon size={12} />
                      </a>
                    )}

                    <button
                      className="btn btn-secondary btn-icon"
                      style={{ padding: '4px' }}
                      onClick={() => onSelect(domain)}
                      title="View Details & Credentials"
                    >
                      <Key size={12} />
                    </button>

                    <button
                      className="btn btn-secondary btn-icon"
                      style={{ padding: '4px' }}
                      onClick={() => onEdit(domain)}
                      title="Edit"
                    >
                      <Edit2 size={12} />
                    </button>

                    <button
                      className="btn btn-danger btn-icon"
                      style={{ padding: '4px' }}
                      onClick={() => onDelete(domain.id)}
                      title="Delete"
                    >
                      <Trash2 size={12} />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
